export const clinicalCareStatus = {
  requested: 'Solicitado',
  revision: 'Em vistoria',
  correction: 'Em correção',
  corrected: 'Corrigido',
  screening: 'Triagem',
  forwarded: 'Encaminhado',
  hospitalized: 'Internado',
  medicalRelease: 'Alta médica',
  death: 'Falecido',
  pullout: 'Em retirada',
  caught: 'Saída',
  done: 'Concluído',
  canceled: 'Cancelado',
  rejected: 'Rejeitado',
  recordAdded: 'Prontuário atualizado',
  priorityChanged: 'Prioridade alterada',
}

export const clinicalCareStatusClasses = {
  requested: 'text-primary',
  revision: 'text-bold text-warning',
  correction: 'text-bold text-warning',
  corrected: 'text-bold text-primary',
  screening: 'text-bold text-primary',
  forwarded: 'text-bold text-primary',
  hospitalized: 'text-bold text-primary',
  medicalRelease: 'text-bold text-success',
  death: 'text-bold text-dark',
  pullout: 'text-bold text-success',
  done: 'text-bold text-success',
  caught: 'text-bold text-success',
  canceled: 'text-bold text-error',
  rejected: 'text-bold text-error',
  priorityChanged: 'text-bold text-warning',
}
